var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.494141C6.15968 0.494141 3.85714 2.84465 3.85714 5.74414C3.85714 8.64363 6.15968 10.9941 9 10.9941C11.8403 10.9941 14.1429 8.64363 14.1429 5.74414C14.1429 2.84465 11.8403 0.494141 9 0.494141ZM2.58265 12.3066C1.16119 12.3066 0 13.4707 0 14.9316C0 17.1513 1.07076 18.8249 2.74499 19.9147C4.39324 20.9875 6.61533 21.4941 9 21.4941C11.3847 21.4941 13.6068 20.9875 15.255 19.9147C16.9292 18.8249 18 17.1513 18 14.9316C18 13.4821 16.8486 12.3066 15.4286 12.3066L2.58265 12.3066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ffa8675b9a1bc3a9a66b21ceda1acd68.svg";
export { ForwardRef as ReactComponent };